 function recheck() {
	var window_top = $(this).scrollTop();
	var window_height = $(this).height();
	var view_port_s = window_top;
	var view_port_e = window_top + window_height;
	$('.animatedSection').each(function () {
		var block = $(this);
		var block_top = block.offset().top;
		var block_height = block.height();

		if (block_top <= view_port_e) {
		  block.addClass('fadeInUp');
		} else {
		   block.removeClass('fadeInUp');

		}
	});
}
 $(function () {
	$(window).scroll(function () {
		recheck();
	});

	$(window).resize(function () {
		recheck();
	});

	recheck();
	 var windowWidth = $(window).width();
	var currentDiv = $("#animateBox1,#animateBoxHead1");
	var nextDiv, count = 1;
	var timesRun = 0;

	var myInterval = setInterval(function () {
		if (count == 4) {
			currentDiv.hide();
			currentDiv.removeClass("outAnimation");
			currentDiv = $("#animateBox1,#animateBoxHead1");
			currentDiv.show();
			currentDiv.addClass("outAnimation");
			count = 1;

		} else {
			count++;
			currentDiv.hide();
			currentDiv.removeClass("outAnimation");
			currentDiv = currentDiv.next();
			currentDiv.show();
			currentDiv.addClass("outAnimation");

		}
	}, 5000);
	
	//mobile menu click function
	$(".mobile-menu-bar").click(function(){
		$(".menu-links-mobile").addClass("show-menu");
		$("body").addClass("no-scroll");
	})
	$(".close-icon").click(function(){
		$(".menu-links-mobile").removeClass("show-menu");
		$("body").removeClass("no-scroll");
	})

	 //Explore  mobile humbarger open
		$(".mobile-humbarger").on('click', function () {
			var icon = $(this).find("i.far");
			icon.removeClass("fa-times");
			$(this).parents(".topHeader").find(".search-section").removeClass("is-active");
			$('.searchBtn').toggleClass('hide');
			$(this).parents(".topHeader").find(".tips-dropdown").toggleClass("is-active");
			if (icon.hasClass("fa-bars")) {
				icon.removeClass("fa-bars").addClass("fa-times")
			}
			else {
				icon.addClass("fa-bars");
			}
		});
	 	//Explore serch bar
		$(".searchBtn").on('click', function (event) {
			event.stopPropagation();
			var sIcon = $(this).find("i.far");
			sIcon.removeClass("fa-times");
			$(this).parents(".topHeader").find(".search-section").toggleClass("is-active");
			document.getElementById('wpSearchBox').value = "";
			document.getElementById('wpSearchResult').classList.remove("show-serch-dropdown");
			if (sIcon.hasClass("fa-search")) {
				sIcon.removeClass("fa-search").addClass("fa-times")
			}
			else {
				sIcon.addClass("fa-search");
			}
		});
		$("body").click(function (e) {
			var container = $(".search-section");
			var oIcon = $(".searchBtn .fa-times");
			if (!container.is(e.target) && container.has(e.target).length === 0) {
				$(".search-section").removeClass("is-active");
				document.getElementById('wpSearchBox').value = "";
				document.getElementById('wpSearchResult').classList.remove("show-serch-dropdown");
				oIcon.removeClass("fa-times").addClass("fa-search")
			}
		});
	//Explore mega menu
	//  if (windowWidth > 1023) {
    //             $('.visible-resume').mouseenter(function () {
    //                 var ripHeight = $(".resume-dropdown").height();
    //                 $(this).parents(".topHeader").find(".resume-dropdown").addClass("is-active");
    //                 $(this).parents(".topHeader").find(".nav-dropdown").addClass("is-active");
    //                 $(this).parents(".topHeader").find(".resumeDrop").attr('style', 'height:' + ripHeight + "px");
    //                 $(".tips-dropdown").removeClass("is-active");
    //                 $(this).addClass("activeNav");

    //             });
    //             $('.visible-tips').mouseenter(function () {
    //                 var tipHeight = $(".tips-dropdown").height();
    //                 $(this).parents(".topHeader").find(".tips-dropdown").addClass("is-active");
    //                 $(".resume-dropdown").removeClass("is-active");
    //                 $(this).parents(".topHeader").find(".nav-dropdown").addClass("is-active");
    //                 $(this).parents(".topHeader").find(".tipDrop").attr('style', 'height:' + tipHeight + "px");
    //                 $(this).addClass("activeNav");

    //             });

    //             $('.visible-resume').mouseleave(function () {
    //                 $(this).parents(".topHeader").find(".resume-dropdown").removeClass("is-active");
    //                 $(this).parents(".topHeader").find(".nav-dropdown").removeClass("is-active").attr('style', 'height: 0');
    //                 $(".tips-dropdown").removeClass("is-active");
    //                 $(this).removeClass("activeNav");

    //             });
    //             $('.visible-tips').mouseleave(function () {
    //                 $(this).parents(".topHeader").find(".tips-dropdown").removeClass("is-active");
    //                 $(".resume-dropdown").removeClass("is-active");
    //                 $(this).parents(".topHeader").find(".nav-dropdown").removeClass("is-active").attr('style', 'height: 0');
    //                 $(this).removeClass("activeNav");
    //             });
    //             $(".navHover").mouseenter(function () {
    //                 $(this).parents(".topHeader").find(".mega-menu").addClass("show");
    //             });
    //             $(".navHover").mouseleave(function () {
    //                 $(this).parents(".topHeader").find(".mega-menu").removeClass("show");
    //             });
	//  }

	 if (windowWidth > 1023) {
		 var visibleResume = document.querySelector(".visible-resume"),
			 visibleTips = document.querySelector(".visible-tips"),
			 navHover = document.querySelector(".navHover"),
			 navDropdown = document.querySelector(".nav-dropdown"),
			 resumeDropdown = document.querySelector(".resume-dropdown"),
			 visibleDropdown = document.querySelector(".tips-dropdown"),
			 megaMenu = document.querySelector(".mega-menu");
		 		
		 		visibleResume.addEventListener('mouseenter', function () {
						console.log(" Resume Mega Menu can be shown now")
						
						visibleResume.classList.add("activeNav"); console.log("activeNav added to visibleResume");
						let ripHeight = resumeDropdown.clientHeight; console.log(ripHeight);

			 			navDropdown.style.height = ripHeight+'px'; console.log("Height added to Resume Drop");
			 			resumeDropdown.classList.add("is-active"); console.log("is active added");
						megaMenu.classList.add("is-active", "show");  console.log("is active and show class added");
					
                });
		 		visibleResume.addEventListener('mouseleave', function () {
						console.log(" Resume Mega Menu can be shown now")
						
						visibleResume.classList.remove("activeNav"); console.log("activeNav removed from visibleResume");
						let ripHeight = resumeDropdown.clientHeight; console.log(ripHeight);

			 			navDropdown.style.height = 0 +'px'; console.log("Height removed from Resume Drop");
			 			resumeDropdown.classList.remove("is-active"); console.log("is active removed");
						megaMenu.classList.remove("is-active", "show");  console.log("is active and show class removed");
					
                });
		 		visibleTips.addEventListener('mouseenter', function () {
						console.log(" Resume Mega Menu can be shown now")
						
						visibleTips.classList.add("activeNav"); console.log("activeNav added to visibleResume");
						let ripHeight = resumeDropdown.clientHeight; console.log(ripHeight);

			 			navDropdown.style.height = ripHeight+'px'; console.log("Height added to Resume Drop");
			 			visibleDropdown.classList.add("is-active"); console.log("is active added");
						visibleDropdown.classList.add("is-active", "show");  console.log("is active and show class added");
					
                });
		 		visibleTips.addEventListener('mouseleave', function () {
						console.log(" Resume Mega Menu can be shown now")
						
						visibleTips.classList.remove("activeNav"); console.log("activeNav removed from visibleResume");
						let ripHeight = resumeDropdown.clientHeight; console.log(ripHeight);

			 			navDropdown.style.height = 0 +'px'; console.log("Height removed from Resume Drop");
			 			visibleDropdown.classList.remove("is-active"); console.log("is active removed");
						visibleDropdown.classList.remove("is-active", "show");  console.log("is active and show class removed");
					
                });
           
	 }	 
	 
	 //Explore Mobile slider
	 if (windowWidth <= 767) {
		 $('.slider-for').slick({  
			 slidesToShow: 1,
			 slidesToScroll: 1,
			 arrows: false,
			 fade: true,
			 asNavFor: '.slider-nav',
			 //autoplay: true,
			 //autoplaySpeed: 8000,
			 loop: true,
			 speed: 10,

               
		 });
		 $('.slider-nav').slick({
			 slidesToShow: 1,
			 slidesToScroll: 1,
			 asNavFor: '.slider-for',
			 dots: true,
			 centerMode: false,
			 focusOnSelect: true,
			 loop: true,
			 arrow: false,
			 adaptiveHeight: true
		 });
	 }	 
	 
});

	var isSessionStorageAvailable = function () {
        var testKey = 'test', storage = window.sessionStorage;
        try {
            if (storage) {
                storage.setItem(testKey, '1');
                storage.removeItem(testKey);
                return true;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    } 
      function setTemplate(skinCD) {
            if (isSessionStorageAvailable()) { 
                sessionStorage.setItem('selectedSkinCD', skinCD);
            }
            window.location.href = "/how-it-works";
        }
		
		function searchWP(e) {
        e.preventDefault();
        searchArticles(document.getElementById('wpSearchBox').value);
    }
    function searchArticles(text) {
        if (text && text.length > 2) {
                var url = "/home/searcharticles" + "?text=" + text + "&num=3";
                if (window.XMLHttpRequest) {
                    // code for modern browsers
                    var xmlhttp = new XMLHttpRequest();
                } else {
                    // code for old IE browsers
                    var xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
                }
                xmlhttp.onreadystatechange = function () {
                    if (this.readyState == 4 && this.status == 200) {
                        var response = JSON.parse(xmlhttp.responseText);
                        var searchResultHTML = '';
                        if (response.length > 0) {
                            searchResultHTML = '<ul>'
                            for (var i = 0; i < response.length; i++) {
                                searchResultHTML += '<li><a target="_blank" href = "' + response[i].slug + '"><div class="search-list-img"><img src = "' + response[i].feautured_image.thumbnail[0] + '" alt = "tips image" height="120" width="120" /></div><div class="serch-list-text"><h3>'
                                    + response[i].title + '</h3><p>' + response[i].description + '</p></div></a></li>';
                            }
                            searchResultHTML += '</ul>';
                        }
                        else {
                            searchResultHTML = '<p class="searchResultNotFount">Sorry, no results found</p>';
                        }
                        document.getElementById('wpSearchResult').innerHTML = searchResultHTML;
                        document.getElementById('wpSearchResult').classList.add("show-serch-dropdown");
                    }
                };
                xmlhttp.open("GET", url, true);
                xmlhttp.send();
        }
            else {
                document.getElementById('wpSearchResult').innerHTML = '';
                document.getElementById('wpSearchResult').classList.remove("show-serch-dropdown");
            }
    }
		

 //Explore cta video

        function openVideo() {
            var ctamodal = document.getElementById("cta-modalvideo");
            document.getElementById("videoModal").play();
            ctamodal.style.display = "block";
        }
        var ctamodal = document.getElementById("cta-modalvideo");
        var closecta = document.getElementsByClassName("close")[0];

        closecta.onclick = function () {
            document.getElementById("videoModal").pause();
            ctamodal.style.display = "none";
        }
        document.body.onclick = function (event) {
            if (event.target == ctamodal) {
                document.getElementById("videoModal").pause();
                ctamodal.style.display = "none";
            }
        }
   
			document.getElementById('vidSource').src = 'https://www.resumenerd.com//video/Nerd-DemoVideo.mp4';
            document.querySelector("video").load();
       

$(function () {
	const els = document.querySelectorAll(`a[href$="how-it-works"]`);
    var params = 0;
	if( els.length === 0 ) {
		return;
	}

	function add_query(el) {
		if( !el.href ) {
			return;
		}
        
		el.addEventListener(
			`click`,
			() => { 
			
			  if(window.location.href.indexOf('?') >= 0 ){
			     params = window.location.href.slice(window.location.href.indexOf('?') + 1);
			  }
			  if(el.href.indexOf('?') < 0)
			  {			  
			    el.href = el.href + ((params.length > 0) ? ('?'+params) : ''); 
			   }
			}
		);
	}

	for( let i = 0; i < els.length; i++ ) {
		add_query(els[i]);
	}
});

